import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import TextField from '@mui/material/TextField'
import React from 'react'
import { Mutation } from 'react-apollo'
import { i18n } from '../../index'
import css from './toiletCheckQuestionForm.css'
import {
  createToiletCheckQuestionMutation,
  toiletCheckQuestionsQuery,
  updateToiletCheckQuestionMutation,
} from './toiletCheckQuestionQueries'
import type { ToiletCheckQuestion } from './toiletCheckQuestionTypes'
type ToiletCheckQuestionFormData = ToiletCheckQuestion
const defaultFormData = {
  id: null,
  description: '',
}

const updateCacheOnCreate =
  (stationId: string | null | undefined) =>
  (cache: any, { data: { createToiletCheckQuestion } }: any) => {
    const variables = stationId
      ? {
          stationId,
        }
      : {}
    const { toiletCheckQuestions } = cache.readQuery({
      query: toiletCheckQuestionsQuery,
      variables,
    })
    cache.writeQuery({
      query: toiletCheckQuestionsQuery,
      variables,
      data: {
        toiletCheckQuestions: [...toiletCheckQuestions, createToiletCheckQuestion],
      },
    })
  }

type Props = {
  data: ToiletCheckQuestion | null | undefined
  stationId?: string
  onSubmit: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
}
type State = {
  formData: ToiletCheckQuestionFormData
}

class ToiletCheckQuestionForm extends React.Component<Props, State> {
  state = {
    formData: { ...defaultFormData },
  }

  componentDidMount() {
    const { data } = this.props

    if (data) {
      this.setStateFromData(data)
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { data } = this.props

    if (data && JSON.stringify(data) !== JSON.stringify(prevProps.data)) {
      this.setStateFromData(data)
    }
  }

  setStateFromData = (data: ToiletCheckQuestion) => {
    this.setState({
      formData: { ...defaultFormData, ...data },
    })
  }
  onInput = (fieldName: string, newValue: string | number) => {
    this.setState({
      formData: { ...this.state.formData, [fieldName]: newValue },
    })
  }
  onSubmit = (onMutate: (...args: Array<any>) => any, e: any) => {
    e.preventDefault()
    const { stationId } = this.props
    const { onSubmit } = this.props
    const { formData } = this.state
    onMutate(
      formData.id
        ? {
            variables: {
              id: formData.id,
              description: formData.description,
            },
          }
        : {
            variables: {
              description: formData.description,
              stationId,
            },
            update: updateCacheOnCreate(stationId),
          },
    )
    onSubmit()
    this.onReset()
  }
  onReset = () => {
    this.setState({
      formData: { ...defaultFormData },
    })
  }

  render() {
    const { onCancel } = this.props
    const { formData } = this.state
    return (
      <Mutation mutation={formData.id ? updateToiletCheckQuestionMutation : createToiletCheckQuestionMutation}>
        {(onMutate) => (
          <form noValidate onSubmit={(e) => this.onSubmit(onMutate, e)} className={css.component}>
            <TextField
              autoFocus
              required
              data-testid='toiletCheckQuestionDescription'
              label={i18n.t('admin.toiletCheckQuestions.label.description')}
              value={formData.description}
              onChange={(e) => this.onInput('description', e.target.value)}
              className={css.textField}
            />
            <DialogActions className={css.actions}>
              <Button type='button' onClick={onCancel}>
                {i18n.t('buttons.cancel')}
              </Button>
              <Button type='submit' color='primary'>
                {i18n.t('buttons.save')}
              </Button>
            </DialogActions>
          </form>
        )}
      </Mutation>
    )
  }
}

export default ToiletCheckQuestionForm
